import { observer } from 'mobx-react-lite';
import Popup from '../../../../../../components/common-components/pop-up/Popup';
import { useStore } from '../../../../../../hooks/useStore';
import { Form, Formik } from 'formik';
import CommonButton from '../../../../../../components/common-components/button/CommonButton';
import { FormikTextField } from '../../../../../../components/form-components/common-components/text-field/FormikTextField';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import styles from './NewHospital.module.css';

const validationSchema = Yup.object({
  hospitalName: Yup.string()
    .required('Hastane adı zorunludur')
    .min(2, 'Hastane adı en az 2 karakter olmalıdır'),
});

const initialValues = {
  hospitalName: '',
};

const NewHospital = () => {
  const { popupStore, hospitalStore, uiStore } = useStore();

  const handleSubmit = async (values: typeof initialValues) => {
    try {
      uiStore.setLoading(true);
      const response = await hospitalStore.newHospital({
        hospitalName: values.hospitalName,
      });
      if (response.error == true) {
        toast.error('Hastane oluşturalamadı. ' + response.message);
      }
      if (response.error == false) {
        toast.success('Hastane başarıyla oluşturuldu.');
        popupStore.setIsNewHospitalOpen(false);
      }
    } catch (error) {
      console.error('Hastane oluşturulurken hata:', error);
      toast.error('Hastane oluşturulurken bir hata oluştu');
    } finally {
      uiStore.setLoading(false);
    }
  };

  const handleClose = () => {
    popupStore.setIsNewHospitalOpen(false);
    toast.dismiss();
  };

  return (
    <Popup isOpen={popupStore.isNewHospitalOpen} onClose={handleClose} title="Yeni Hastane Oluştur">
      <div className={styles.container}>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form className={styles.form}>
              <div className={styles.inputContainer}>
                <FormikTextField
                  name="hospitalName"
                  label="Hastane Adı"
                  placeholder="Hastane adını giriniz"
                />
              </div>

              <div className={styles.buttonContainer}>
                <CommonButton
                  type="primary"
                  disabled={isSubmitting}
                  loading={uiStore.isLoading}
                  className={styles.submitButton}
                >
                  Kaydet
                </CommonButton>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Popup>
  );
};

export default observer(NewHospital);
